import service from '@/utils/service'

/**
 * @Description:  登录
 * @param:
 * @Author: ZhangBin
 * @Date 2019/3/28 上午11:14
 */
export function loginByUsername(params) {
  return service.post('/login/self', params)
}
/**
 * @Description:  登出
 * @param:
 * @Author: ZhangBin
 * @Date 2018/4/4 下午1:44
 */
export function logout(params) {
  return service({
    url: '/logout',
    method: 'get',
    params: params
  })
}
/**
 * @Description:  获取用户菜单
 * @param:
 * @Author: ZhangBin
 * @Date 2018/4/1 上午9:56
 */
export function getUserMenu(token) {
  return service({
    url: '/model/userModel',
    method: 'get',
    params: token
  })
}

/**
 * @Description:  修改密码
 * @param:
 * @Author: ZhangBin
 * @Date 2019/3/29 上午10:00
 */
export function setPassWord(params) {
  return service({
    url:'/user/changePassWord',
    method: 'put',
    params: params
  })
}
/**
 * @Description:  获取用户可用功能
 * @param:
 * @Author: ZhangBin
 * @Date 2019-05-17 16:56
 */
export function getUserFunction(params) {
  return service({
    url:'/menu/getMenuFunction',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js